<template>
    <div class="ratio"  :class="{'ratio-sport': isSport}">
        <div class="row justify-center items-center image cursor-pointer" :class="{'zoom': zoom}">
            <img @click.prevent="$watchUser('item', item)" v-lazy="img.url" :key="img.url"
                 :style="{'object-position': img.focalPoint ? img.focalPoint : false}">
            <div v-if="isVideo" class="has-video"></div>
        </div>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'VImg',

        props: {
            img: {
                type: Object,
                required: true
            },
            item: {
                type: Object,
                required: true
            },
            zoom: {
              default: true,
              type: Boolean
            },
            isSport: {
              default: false,
              type: Boolean
            },
            isVideo: Boolean
        }
    }
</script>

<style scoped>
.ratio-sport {
    width: 60% !important;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/front/Image.vue